import styled from "styled-components";
import { Container } from "../../AppStyle";
import { Link } from "react-router-dom";
import { NavLink } from "react-router-dom";

export const Nav = styled.nav`
  background: ${({ theme }) => theme.nav};
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.8rem;
  position: sticky;
  top: 0;
  z-index: 50;
  width: 100%;

  transition: background-color 0.3s ease-in;
`;

export const NavbarContainer = styled(Container)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 80px;
  width: 100%;
  padding: 0 1.5rem;
  position: relative;

  @media (max-width: 960px) {
    justify-content: center;
    position: relative;

    .theme-switch {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 60;
    }

    .mobile-icon {
      position: absolute;
      top: 50%;
      right: 1.5rem;
      transform: translateY(-50%);
      z-index: 60;
    }
  }
`;

export const NavLogo = styled(Link)`
  color: #fff;
  justify-self: flex-start;
  cursor: pointer;
  text-decoration: none;
  font-size: 2rem;
  display: flex;
  align-items: center;
  z-index: 50;
  position: absolute;
  left: 1.5rem;
  top: 50%;
  transform: translateY(-50%);
`;

export const NavIcon = styled.img`
  margin-right: 1rem;
  width: 3rem;
`;

export const NavMenu = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  width: auto;
  margin-left: auto;
  background: transparent;

  @media (max-width: 960px) {
    flex-direction: column;
    align-items: center;
    text-align: center;

    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    padding-top: 30%;
    background: ${({ theme }) => theme.nav};
    transition: background-color 0.3s ease, color 0.3s ease;

    opacity: ${({ show }) => (show ? 1 : 0)};
    visibility: ${({ show }) => (show ? "visible" : "hidden")};
    transform: translateY(${({ show }) => (show ? "0" : "-10px")});
    transition: opacity 0.5s ease;
  }
`;

export const NavItem = styled.li`
  cursor: pointer;

  @media screen and (max-width: 960px) {
    width: 100%;

    &:hover {
      border: none;
    }
  }
`;

export const NavBtnLink = styled(NavLink)`
  display: block;
  text-decoration: none;
  padding: 8px 16px;
  width: 100%;
  box-sizing: border-box;
  border: none;
  outline: none;
  font-weight: 650;
  color: ${({ theme }) => theme.text};

  &.active {
    color: ${({ theme }) => theme.subtext};
    font-weight: bold;
  }

  &:not(.active):hover {
    color: ${({ theme }) => theme.subtext};
    font-weight: normal;
  }
`;

export const MobileIcon = styled.div`
  display: none;

  @media screen and (max-width: 960px) {
    display: block;
    font-size: 1.8rem;
    cursor: pointer;
    color: ${({ theme }) => theme.text};
  }
`;

export const ThemeSwitchContainer = styled.div`
  width: 60px;
  height: 30px;
  margin-right: 1em;
  background-color: ${({ isDarkMode }) => (isDarkMode ? "#27272A" : "#E4E4E7")};
  border-radius: 30px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: ${({ isDarkMode }) =>
    isDarkMode ? "flex-start" : "flex-end"};
  padding: 3px;

  @media (max-width: 960px) {
    margin-right: 0;
  }

  @media (max-width: 480px) {
    width: 50px;
    height: 26px;
    padding: 2px;
  }
`;

export const Slider = styled.div`
  width: 24px;
  height: 24px;
  background-color: ${({ isDarkMode }) => (isDarkMode ? "#141414" : "#fff")};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.3s ease;

  @media (max-width: 480px) {
    width: 20px;
    height: 20px;
  }
`;

export const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 14px;
    height: 14px;

    @media (max-width: 480px) {
      width: 12px;
      height: 12px;
    }
  }
`;
